import React from 'react';
import { InputCheckbox as InputCheckboxComponent } from '@brenger/react';
import { InputMeta, InputWrapper, ModifiedInput } from '.';
import cn from 'classnames';

interface InputCheckboxProps extends Omit<ModifiedInput, 'id'> {
  onChange: () => void;
  wrapperClass?: string;
  meta?: InputMeta;
  label: React.ReactNode;
  checked: boolean;
  id: string;
}

export const InputCheckbox: React.FC<InputCheckboxProps> = ({
  wrapperClass,
  meta,
  label,
  checked,
  id,
  name,
  onChange,
}) => {
  return (
    <InputWrapper {...meta} className={cn(wrapperClass, 'input--checkbox')}>
      <div className="flex gap-2 items-start">
        <div className="relative top-[-0.1em]">
          <InputCheckboxComponent id={id} name={name} checked={checked} onChange={onChange} />
        </div>
        <label htmlFor={id}>{label}</label>
      </div>
    </InputWrapper>
  );
};
